import { AppBar, CircularProgress, Divider, Grid, Toolbar, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AppIcon from '../../commonComponents/AppIcon'
import { paddingHorizontal } from '../../utils/AppConstants'
import { useTheme } from '@mui/styles'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../commonComponents/TextStyling'
import AppButton from '../../commonComponents/AppButton'
import { colorWithOpacity } from '../../utils/AppHelper'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import serverData from '../../api/ServerData'
import NoRecordFound from '../../commonComponents/NoRecordFound'

export default function FAQ() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [isRecruiterTab, setIsRecruiterTab] = useState(true)

  const [openCategory, setOpenCategory] = useState(0)
  const [openQuestion, setOpenQuestion] = useState(null)
  const [arrowUpDowm, setArrowUpDowm] = useState(false)

  const [loading, setLoading] = useState(true)

  const [rowsData, setRowsData] = useState({
    recruiterFAQ: [],
    employerFAQ: []
  })

  useEffect(function () {
    getFAQquestions()
  }, [])

  function getFAQquestions() {
    serverData.getFAQs(
      {},
      result => {
        if (result.status) {
          setRowsData(result?.response)
        }
        setLoading(false)
      },
      error => { }
    )
  }

  const FAQquestions = isRecruiterTab
    ? rowsData?.recruiterFAQ
    : rowsData?.employerFAQ

  return (
    <Grid
      container
      style={{
        borderRadius: '16px',
        background: theme.palette.background.paper,
        padding: 24
      }}
    >
      {loading ? (
        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Grid item>
              <AppButton
                name={'Recruiter'}
                onClick={() => {
                  setIsRecruiterTab(true)
                  setOpenCategory(null)
                  setOpenQuestion(null)
                  setArrowUpDowm(false)
                }}
                style={{
                  width: 'fit-content',
                  padding: '12px 26px',
                  borderRadius: '8px',
                  backgroundColor: isRecruiterTab
                    ? theme.palette.primary.main
                    : colorWithOpacity(theme.palette.text.disabled, 0.1),

                  color: isRecruiterTab
                    ? theme.palette.background.paper
                    : theme.palette.text.primary,
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: 700
                }}
              />
            </Grid>
            <Grid item style={{ marginLeft: 24 }}>
              <AppButton
                name={'Employer'}
                onClick={() => {
                  setIsRecruiterTab(false)
                  setOpenCategory(null)
                  setOpenQuestion(null)
                  setArrowUpDowm(false)
                }}
                style={{
                  width: 'fit-content',
                  padding: '12px 26px',
                  borderRadius: '8px',
                  backgroundColor: isRecruiterTab
                    ? colorWithOpacity(theme.palette.text.disabled, 0.1)
                    : theme.palette.primary.main,
                  color: isRecruiterTab
                    ? theme.palette.text.primary
                    : theme.palette.background.paper,
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: 700
                }}
              />
            </Grid>
          </Grid>

          {FAQquestions.length > 0 ? (
            <Grid container style={{ marginTop: 24 }} >
              {FAQquestions?.map((category, catIndex) => (
                <Grid container key={catIndex}>
                  <Grid
                    item
                    xs={12}
                    onClick={() => {
                      setOpenCategory(openCategory === catIndex ? null : catIndex)
                      setOpenQuestion(openQuestion === catIndex ? null : catIndex)
                      setArrowUpDowm(openQuestion === catIndex ? null : catIndex)

                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <Grid
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                    <TextBold style={{ fontSize: isMobile ? '14px' : '18px' }}>
                      {category.category}
                    </TextBold>
                    {arrowUpDowm === catIndex ? (
                            <KeyboardArrowUpIcon
                              style={{ color: theme.palette.text.secondary }}
                            />
                          ) : (
                            <KeyboardArrowDownIcon
                              style={{ color: theme.palette.text.secondary }}
                            />
                          )}
                    </Grid>
                  </Grid>
                  {openCategory === catIndex &&
                    category.queAns.map((item, queIndex) => (
                      <Grid container key={queIndex}>
                        <Grid
                          item
                          xs={12}
                          onClick={() => {
                            setOpenQuestion(
                              openQuestion === queIndex ? null : queIndex
                            )
                            setArrowUpDowm(
                              openQuestion === queIndex ? false : queIndex
                            )
                          }}
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 16,
                            marginLeft: 16
                          }}
                        >
                          {arrowUpDowm === queIndex ? (
                            <KeyboardArrowUpIcon
                              style={{ color: theme.palette.text.secondary }}
                            />
                          ) : (
                            <KeyboardArrowDownIcon
                              style={{ color: theme.palette.text.secondary }}
                            />
                          )}

                          <TextSemiBold
                            style={{
                              fontSize: isMobile ? '12px' : '16px',
                              color: theme.palette.primary.main,
                              paddingLeft: '8px'
                            }}
                          >
                            {item.question}
                          </TextSemiBold>
                        </Grid>
                        {openQuestion === queIndex && (
                          <Grid item xs={12} style={{ marginLeft: 48 }}>
                            <TextRegular
                              style={{
                                fontSize: isMobile ? '12px' : '16px'
                              }}
                              dangerouslySetInnerHTML={{
                                __html: item.answer
                              }}
                            />
                          </Grid>
                        )}
                      </Grid>
                    ))}
                  <Grid item xs={12}>
                    <Divider style={{ width: '100%', margin: '16px 0px' }} />
                  </Grid>
                </Grid>
              ))}
            </Grid>
          ) : (
            <NoRecordFound />
          )}
        </>
      )}
    </Grid>
  )
}
